import MainLayout from 'Components/Layout/MainLayout';
import React, {useRef} from 'react';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useTable from '../../../Utils/Hooks/useTable';
import Style from '../../Reptile/Website/index.module.scss';
import {Button, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import DeleteConfirm from '../../../Components/DeleteConfirm';
import EditModal from './Components/EditModal';
import useModalHandler from '../../../Utils/Hooks/useModalHandler';
import {useMutation} from 'react-query';
import {Mcp} from './service';
import StatusTag from 'Components/StatusTag';
import McpFunDrawer from './Components/McpFunDrawer';

const Index = () => {
    const {tableInit} = useTable(Mcp.list, {});
    const tableRef = useRef<TableContext>(null);

    function reload() {
        tableRef?.current?.refresh();
    }
    const editModal = useModalHandler({
        component: EditModal,
    });

    const mcpFunDrawer = useModalHandler({
        type: 'drawer',
        component: McpFunDrawer,
    });

    const onDelete = useMutation({
        mutationFn: Mcp.remove,
        onSuccess: () => {
            reload();
        },
    });

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            onOk: () => {
                                editModal.close();
                                reload();
                            },
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    const columns: ProColumnsType<Mcp.List> = [
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '编码',
            dataIndex: 'code',
        },
        {
            title: '基础Url',
            dataIndex: 'baseUrl',
        },
        {
            title: '监听Url',
            dataIndex: 'listenUrl',
        },
        {
            title: '启用状态',
            dataIndex: 'status',
            width: 100,
            render: (text: boolean) => <StatusTag status={text} />,
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            width: 160,
            align: 'center',
            render: (id: string) => (
                <Space>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            mcpFunDrawer.open({
                                mcpId: id,
                                onOk: () => {
                                    mcpFunDrawer.close();
                                    reload();
                                },
                            });
                        }}>
                        函数
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            editModal.open({
                                id,
                                onOk: () => {
                                    editModal.close();
                                    reload();
                                },
                            });
                        }}>
                        修改
                    </Button>
                    <DeleteConfirm onSuccess={() => onDelete.mutate(id)}>
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </DeleteConfirm>
                </Space>
            ),
        },
    ];

    return (
        <MainLayout.SpaceWrapper padding>
            <TableRender
                rowKey="id"
                ref={tableRef}
                loading={onDelete.isLoading}
                columns={columns}
                toolbarRender={toolBar}
                scroll={{x: 'max-content'}}
                {...tableInit()}
            />

            {editModal.render()}
            {mcpFunDrawer.render()}
        </MainLayout.SpaceWrapper>
    );
};

export default Index;
